export default "__VITE_ASSET__F9KhOyx5__"